module.exports = __webpack_public_path__ + "img/button_prospekt_en.ee955ace.png";